// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__3_1Xl","footer":"ModalCreateQualiphyProcedure_footer__2dz3Q","additionData":"ModalCreateQualiphyProcedure_additionData__1yls-"};